import { render, staticRenderFns } from "./SocialDisplaySettings.vue?vue&type=template&id=5f8c10dc&scoped=true"
import script from "./SocialDisplaySettings.vue?vue&type=script&lang=js"
export * from "./SocialDisplaySettings.vue?vue&type=script&lang=js"
import style0 from "./SocialDisplaySettings.vue?vue&type=style&index=0&id=5f8c10dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c10dc",
  null
  
)

export default component.exports